import {Podiumdata} from '@salaby/pdlib';
import {Navigation, Header, Footer, Utilities, globals} from '@salaby/menu-components-2';
import {ImageHandler, SoundHandler, TextHandler, TextFileHandler, GroupHandler} from '@salaby/handlers';

export default class Game {

    constructor() {

        Utilities.initClickBorderRemoval();

        Utilities.createPodiumGroups(
            Podiumdata,
            ImageHandler,
            SoundHandler,
            TextHandler,
            TextFileHandler,
            GroupHandler
        );

        this._navigation = new Navigation();

        const settingsPG = globals.pg.getGroup('settings');

        this.currentSectionIndex = 0;
        this.currentSectionContainer = null;
        this.sectionsPG = globals.pg.getGroup('sections').getGroups('');

        const headerLinksContainer = Utilities.createElement(document.body, 'div', 'header-links-container');
        const headerPG = globals.pg.getGroup('header');
        const headerContainer = Utilities.createElement(headerLinksContainer, 'div', 'header-container', null, null, headerPG.getImage('image_background').getUrl());
        Utilities.createElement(headerContainer, 'h2', 'header-top-text', null, headerPG.getText('text_top').asString());
        headerPG.getText('image_logo').getImage().h.appendImageElement(headerContainer, headerPG.getText('image_logo').asString(), null, null);
        Utilities.createElement(headerContainer, 'h2', 'header-bottom-text', null, headerPG.getText('text_bottom').asString());

        const linksJson = JSON.parse(liquidData.LinksJson);
        for (let i = 0; i < linksJson.length; i++) {
            if (i === 0) {
                this.createNewSection();
            } else if (linksJson[i].startsNewRow === true) {
                if (this.currentSectionIndex + 1 < this.sectionsPG.length) {
                    this.currentSectionIndex += 1;
                    this.createNewSection();
                }
            }
            this.createLink(linksJson[i]);
        }
        this._footer = new Footer();
    }

    createNewSection() {

        const width = this.sectionsPG[this.currentSectionIndex].getParameter('width').asString().replace('px', '');
        const marginString = this.sectionsPG[this.currentSectionIndex].getParameter('margin').asString();
        const marginNumber = Number(marginString.replace('px', ''));
        const columnsMax = this.sectionsPG[this.currentSectionIndex].getParameter('columns_max').asNumber();

        const maxWidth = (((columnsMax * 2) * marginNumber) + (marginNumber * 2)) + (width * columnsMax);

        const linksWrapper = Utilities.createElement(document.body, 'div', null, 'links-wrapper');

        const backgroundImage = this.sectionsPG[this.currentSectionIndex].getImageOptional('image_background', null);
        if (backgroundImage !== null) {
            backgroundImage.h.load(() => {
                linksWrapper.style.backgroundImage = 'url(\'' + backgroundImage.getUrl() + '\')';
                linksWrapper.style.paddingBottom = backgroundImage.h.getHeight() + 'px';
            });
        }

        linksWrapper.style.backgroundColor = this.sectionsPG[this.currentSectionIndex].getParameter('color_background').asString();
        const sectionHeader = Utilities.createElement(linksWrapper, 'h1', null, null, this.sectionsPG[this.currentSectionIndex].getText('title').asString());
        sectionHeader.style.color = this.sectionsPG[this.currentSectionIndex].getParameter('color_text_header').asString();
        
        const linksContainer = Utilities.createElement(linksWrapper, 'div', null, 'links-container');
        linksContainer.style.maxWidth = maxWidth + 'px';
        linksContainer.style.paddingLeft = marginString;
        linksContainer.style.paddingRight = marginString;
        this.currentLinksContainer = linksContainer;
    }

    createLink(linkJson) {

        const width = this.sectionsPG[this.currentSectionIndex].getParameter('width').asString();
        const height = this.sectionsPG[this.currentSectionIndex].getParameter('height').asString();
        const margin = this.sectionsPG[this.currentSectionIndex].getParameter('margin').asString();
        const type = this.sectionsPG[this.currentSectionIndex].getParameter('type').asString();
        const sizeFont = this.sectionsPG[this.currentSectionIndex].getParameter('size_font').asString();
        const colorBackgroundText = this.sectionsPG[this.currentSectionIndex].getParameter('color_background_text').asString();

        const link = Utilities.createElement(this.currentLinksContainer, 'a', null, 'link');
        link.href = liquidData.SiteUri + linkJson.uri;
        link.style.width = width;

        link.style.margin = margin;

        const img = Utilities.createElement(link, 'img', null, 'link-image');
        img.src = linkJson.image.uri;

        if (type === 'box') {
            link.style.height = height;
            img.style.borderRadius = '8px';
            const linkTextWrapper = Utilities.createElement(link, 'div', null, 'link-text-wrapper');
            const linkLabel = Utilities.createElement(linkTextWrapper, 'p', null, 'link-box-Label', linkJson.written);
            linkLabel.style.backgroundColor = colorBackgroundText;
            linkLabel.style.fontSize = sizeFont;
        } else {
            const linkLabel = Utilities.createElement(link, 'p', null, 'link-outline-Label', linkJson.written);
            linkLabel.style.fontSize = sizeFont;
            linkLabel.style.fontFamily = 'Roboto Slab';
        }
    }
}
